import { render } from "./JobDeleteModal.vue?vue&type=template&id=28d5c9b9&scoped=true&ts=true"
import script from "./JobDeleteModal.vue?vue&type=script&lang=ts"
export * from "./JobDeleteModal.vue?vue&type=script&lang=ts"

import "./JobDeleteModal.vue?vue&type=style&index=0&id=28d5c9b9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d5c9b9"]])

export default __exports__